import { configureStore, createSlice } from '@reduxjs/toolkit';
import endUserAPI from 'src/services/end-user-query';
import permissionAPI from 'src/services/permission-query';
import staffAPI from 'src/services/staff-query';
import uploadAPI from 'src/services/upload-query';
import utilsAPI from 'src/services/utils-query';
import vendorAPI from 'src/services/vendor-query';
import vehicleMakeAPI from 'src/services/vehicle-make-query';
import vehicleModelAPI from 'src/services/vehicle-model-query';
import vehicleUtilityAPI from 'src/services/vehicle-utility-query';
import typeAPI from 'src/services/type-query';
import vehicleAllAPI from 'src/services/vehicle-all-query';
import vehicleSubmissionsAPI from 'src/services/vehicle-submissions-query';
import bookingsAPI from 'src/services/bookings-query';
import vehicleAddonsAPI from 'src/services/vehicle-addons-query';
import reportingAPI from 'src/services/vehicle-reporting';
import revenueAPI from 'src/services/revenue-query';
import rewardAPI from 'src/services/reward-query';
import legalAPI from 'src/services/legal-query';
import faqAPI from "src/services/faq-query";
import chatAPI from "src/services/chatAPI";
import claimsAndDisputesAPI from 'src/services/claims-and-disputes';
import ancillaryFeesAPI from 'src/services/ancillary-fees-query';
import refundAPI from 'src/services/refund-query';
import notificationAPI from 'src/services/notification-query';

const homeSlice = createSlice({
  name: "home",
  initialState: {
    user: null,
    myPermissions: null,
    selectedCurrency: {
      code: 'LKR',
      name: 'Sri Lankan Rupee',
      symbol: 'Rs.',
      country: 'Sri Lanka'
    },
    platformAllowedCountries: ['lk'], //https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2
    timezone: 'Asia/Colombo'
  },
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
    },
    setMyPermissions: (state, action) => {
      state.myPermissions = action.payload;
    },
    setTimezone: (state, action) => {
      state.timezone = action.payload;
    }
  }
});

export const store = configureStore({
  reducer: {
    home: homeSlice.reducer,
    [staffAPI.reducerPath]: staffAPI.reducer,
    [permissionAPI.reducerPath]: permissionAPI.reducer,
    [endUserAPI.reducerPath]: endUserAPI.reducer,
    [vendorAPI.reducerPath]: vendorAPI.reducer,
    [uploadAPI.reducerPath]: uploadAPI.reducer,
    [utilsAPI.reducerPath]: utilsAPI.reducer,
    [vehicleMakeAPI.reducerPath]: vehicleMakeAPI.reducer,
    [vehicleModelAPI.reducerPath]: vehicleModelAPI.reducer,
    [vehicleUtilityAPI.reducerPath]: vehicleUtilityAPI.reducer,
    [typeAPI.reducerPath]: typeAPI.reducer,
    [vehicleAllAPI.reducerPath]: vehicleAllAPI.reducer,
    [vehicleSubmissionsAPI.reducerPath]: vehicleSubmissionsAPI.reducer,
    [bookingsAPI.reducerPath]: bookingsAPI.reducer,
    [vehicleAddonsAPI.reducerPath]: vehicleAddonsAPI.reducer,
    [reportingAPI.reducerPath]: reportingAPI.reducer,
    [revenueAPI.reducerPath]: revenueAPI.reducer,
    [rewardAPI.reducerPath]: rewardAPI.reducer,
    [legalAPI.reducerPath]: legalAPI.reducer,
    [faqAPI.reducerPath]: faqAPI.reducer,
    [chatAPI.reducerPath]: chatAPI.reducer,
    [claimsAndDisputesAPI.reducerPath]: claimsAndDisputesAPI.reducer,
    [ancillaryFeesAPI.reducerPath]: ancillaryFeesAPI.reducer,
    [refundAPI.reducerPath]: refundAPI.reducer,
    [notificationAPI.reducerPath]: notificationAPI.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware()
    .concat(staffAPI.middleware)
    .concat(permissionAPI.middleware)
    .concat(endUserAPI.middleware)
    .concat(vendorAPI.middleware)
    .concat(uploadAPI.middleware)
    .concat(utilsAPI.middleware)
    .concat(vehicleMakeAPI.middleware)
    .concat(vehicleModelAPI.middleware)
    .concat(vehicleUtilityAPI.middleware)
    .concat(typeAPI.middleware)
    .concat(vehicleAllAPI.middleware)
    .concat(vehicleSubmissionsAPI.middleware)
    .concat(bookingsAPI.middleware)
    .concat(vehicleAddonsAPI.middleware)
    .concat(reportingAPI.middleware)
    .concat(revenueAPI.middleware)
    .concat(rewardAPI.middleware)
    .concat(legalAPI.middleware)
    .concat(faqAPI.middleware)
    .concat(chatAPI.middleware)
    .concat(claimsAndDisputesAPI.middleware)
    .concat(ancillaryFeesAPI.middleware)
    .concat(refundAPI.middleware)
    .concat(notificationAPI.middleware)
})

export const homeActions = homeSlice.actions;